import { create } from 'zustand';
import {
  deleteRole,
  fetchRoleById,
  fetchRoles,
  FetchRolesRequest,
  postRole,
  putRole,
  RoleType,
} from './api/role-api';
import { useAlertStore } from './use-alert-store';

interface Store {
  roles?: RoleType[];
  fetchRoleById: (id: string) => Promise<RoleType | undefined>;
  fetchRoles: (data: FetchRolesRequest) => Promise<void>;
  postRole: (data: Partial<RoleType>) => Promise<void>;
  putRole: (data: Partial<RoleType>) => Promise<void>;
  deleteRole: (id: string) => Promise<void>;
  isLoading?: boolean;
}

export const useRoleStore = create<Store>((set, get) => ({
  fetchRoleById: async (id) => {
    set({ isLoading: true });
    try {
      const resp = await fetchRoleById(id);
      return resp;
    } catch (e) {
      console.error(e);
      useAlertStore.getState().add({ label: 'Не удалось получить роль', variant: 'danger' });
      return undefined;
    } finally {
      set({ isLoading: false });
    }
  },
  fetchRoles: async (data) => {
    set({ isLoading: true });
    try {
      const resp = await fetchRoles(data);
      set({ roles: resp });
    } catch (e) {
      console.error(e);
      useAlertStore
        .getState()
        .add({ label: 'Не удалось получить список ролей', variant: 'danger' });
    } finally {
      set({ isLoading: false });
    }
  },
  postRole: async (data) => {
    set({ isLoading: true });
    try {
      const resp = await postRole(data);
      set({ roles: [resp, ...(get().roles || [])] });
      useAlertStore.getState().add({ label: 'Роль успешно создана', variant: 'success' });
    } catch (e) {
      console.error(e);
      useAlertStore.getState().add({ label: 'Не удалось создать роль', variant: 'danger' });
      throw e;
    } finally {
      set({ isLoading: false });
    }
  },
  putRole: async (data) => {
    set({ isLoading: true });
    try {
      const resp = await putRole(data);
      set({ roles: get().roles?.map((item) => (item.id === data.id ? resp : item)) });

      useAlertStore.getState().add({ label: 'Роль успешно обновлена', variant: 'success' });
    } catch (e) {
      console.error(e);
      useAlertStore.getState().add({ label: 'Не удалось обновить роль', variant: 'danger' });
      throw e;
    } finally {
      set({ isLoading: false });
    }
  },
  deleteRole: async (id) => {
    set({ isLoading: true });
    try {
      await deleteRole(id);
      set({ roles: get().roles?.filter((item) => item.id !== id) });
      useAlertStore.getState().add({ label: 'Роль успешно удалена', variant: 'success' });
    } catch (e) {
      console.error(e);
      useAlertStore.getState().add({ label: 'Не удалось удалить роль', variant: 'danger' });
      throw e;
    } finally {
      set({ isLoading: false });
    }
  },
}));
